import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ gap }) => css`
    align-items: center;
    justify-content: space-between;
    display: flex;
    width: 100%;
    gap: ${gap || 0};

    @media screen and (max-width: 1200px) {
      width: unset;
      gap: 16px;
    }
  `}
`

export const PageContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media screen and (max-width: 1040px) {
    padding: 0 16px;
  }
`

export const AlignWrappers = styled.div`
  width: 100%;
  max-width: 1040px;
  margin-bottom: 24px;

  @media screen and (max-width: 1200px) {
    margin-left: 0;
  }
`

export const WrapperTitle = styled.h2`
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  padding-top: 16px;
  color: var(--gray-2);

  ${({ noPaddingTop }) => noPaddingTop && 'padding-top: 0;'}
`

export const WrapperSubtitle = styled.h3`
  color: var(--gray-5);
  font-family: var(--primary-font);
  font-size: 14px;
  font-weight: 400;
  line-height: 20.3px;
  padding: 8px 0;
`

export const TimeContent = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-self: stretch;
  border-radius: 2.4rem;
  border: 1px solid var(--silver);
  margin: 24px 0;
  hr {
    border-color: var(--silver);
    margin: 16px 0;
    opacity: .25;
  }
`

export const Period = styled.div`
  h3 {
    color: var(--gray-2);
    font-family: var(--primary-font);
    font-size: 14px;
    font-weight: 600;
    line-height: 16.8px;
    margin-bottom: 16px;
  }
`

export const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 24px 0;
  border-radius: 2.4rem;
  border: 1px solid var(--silver);
  padding: 16px;
`

export const WrapperTags = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  margin: 16px -15px 8px 0;
`
export const NoticeCard = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 2.4rem;
  background: ${({ type }) => type === 'warning' ? 'var(--clean-gray)' : 'var(--pet-anjo-light-blue)'};
  color: var(--gray-5);
  font-family: var(--primary-font);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 145%;
  margin-top: ${({ marginTop }) => marginTop || '0'};
`

export const CaptionsWrapper = styled.div`
  border-top: 1px solid var(--silver);
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`
export const CaptionsTitle = styled.h4`
  color: var(--the-black);
  text-align: center;
  font-family: var(--primary-font);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14.4px;
`

export const Captions = styled.dl`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
`

export const CaptionItem = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const Color = styled.div`
  background-color: ${({ color }) => color};
  border: ${({ border }) => border};
  border-radius: 100px;
  height: 20px;
  width: 20px;
`

export const Caption = styled.span`
  font-family: var(--primary-font);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: left;
  color: var(--gray-5);
`
